import { createPinia } from "pinia";
import { createApp } from "vue";

import "./assets/styles/reset.css";
import "./assets/styles/font.css";
import "./assets/styles/styles.css";
import App from "./App.vue";
import router from "./router";
import { initSentry } from "./services/sentry.ts";

import { useKakao } from "@/shared/auth/composables/useKakao";
const { initKakao } = useKakao();

initKakao();
const pinia = createPinia();
const app = createApp(App);

initSentry(app, router);

app.use(pinia);
app.use(router);
app.mount("#app");
